module.exports = __webpack_public_path__ + "img/icon-chat.1501cea0.svg";